const GEOCALC_LIST_REQUESTED = 'GEOCALC_LIST_REQUESTED';

const requestGeoCalcListAction = () => {
    return {
        type: GEOCALC_LIST_REQUESTED
    };
};

export {GEOCALC_LIST_REQUESTED, requestGeoCalcListAction};
